/**
 * Countdown timer
 * @requires https://github.com/BrooonS/timezz
 */

export default (() => {
  const timers = document.querySelectorAll('[data-countdown-date]')

  if (timers.length === 0) return

  timers.forEach((timer) => {
    const date = timer.dataset.countdownDate

    /* eslint-disable no-undef */
    timezz(timer, {
      date,
      // add more options here
    })
    /* eslint-enable no-undef */
  })
})()
